"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(require("D:\\\u9879\u76EE\u7BA1\u7406\\\u65E7\u6362\u65B0\\\u6E90\u7801\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\@babel\\runtime\\regenerator\\index.js"));

var _customerInfo = _interopRequireDefault(require("@/components/customerInfo"));

var _marketing = require("@/api/marketing");

var _validate = require("@/utils/validate");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = {
  name: "addClerk",
  components: {
    customerInfo: _customerInfo.default
  },
  // props: {
  //   storeSelectList: Array
  // },
  data: function data() {
    return {
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < new Date().setTime(new Date().getTime() - 3600 * 1000 * 24); //不限制未来时间
          // return time.getTime() < Date.now() - 8.64e7 || time.getTime() > Date.now() + 600 * 8.64e7; //限制未来时间
        }
      },
      loading: false,
      dialogFormVisible: false,
      id: 0,
      ruleForm: {
        id: null,
        activityName: null,
        activityStartime: null,
        activityEndtime: null,
        termTime: []
      },
      termTime: [],
      name: '',
      rules: {
        activityName: [{
          required: true,
          message: '请填写活动名称',
          trigger: 'change'
        }],
        termTime: [{
          required: true,
          message: '请填写活动开始时间',
          trigger: 'change'
        }] // activityEndtime: [
        //   { required: true, message: '请填写活动结束时间', trigger: 'change' }
        // ]

      }
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    //营业时间
    onchangeTime: function onchangeTime(e) {
      console.log("选中", e); // this.termTime=[e[0],e[1]];
    },
    //接收来自子集的值；
    upImgUid: function upImgUid(row) {
      this.ruleForm.avatar = row.account;
      this.ruleForm.uid = row.id;
    },
    upImg: function upImg() {
      this.$refs.customer.dialogFormVisible = true;
      this.$refs.customer.tableList();
    },
    //详情
    getInfo: function getInfo(id) {
      var _this = this;

      console.log("id", id);
      this.id = id;
      this.loading = true;
      (0, _marketing.activityInfoApi)(id).then(function (res) {
        _this.ruleForm = res;
        _this.termTime = [];

        _this.termTime.push(res.activityStartime || 0);

        _this.termTime.push(res.activityEndtime || 0);

        _this.$forceUpdate();

        console.log("this.ruleForm", _this.ruleForm);
        _this.loading = false;
      }).catch(function (res) {
        _this.loading = false;
      });
    },
    //取消
    cancel: function cancel() {
      this.dialogFormVisible = false;
      this.clearFrom();
      this.resetForm('ruleForm');
      this.ruleForm.avatar = '';
      this.id = 0;
    },
    //数据归为初始状态
    clearFrom: function clearFrom() {
      this.ruleForm.phone = '';
      this.ruleForm.staffName = '';
    },
    //重置
    resetForm: function resetForm(name) {
      this.$refs[name].resetFields();
    },
    // 提交
    submitForm: (0, _validate.Debounce)(function (name) {
      var _this2 = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          if (!_this2.ruleForm.activityName) {
            _this2.$message.info("请填写活动名称");

            return;
          }

          if (!_this2.termTime) {
            _this2.$message.info("请填写活动时间");

            return;
          }

          _this2.ruleForm.activityStartime = _this2.termTime[0];
          _this2.ruleForm.activityEndtime = _this2.termTime[1];
          (0, _marketing.activityAddApi)(_this2.ruleForm).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee() {
            return _index.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _this2.$message.success('提交成功');

                    _this2.dialogFormVisible = false;

                    _this2.$emit("tableList");

                    _this2.clearFrom();

                    _this2.resetForm(name);

                    _this2.id = 0;

                  case 6:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          })));
        } else {
          return false;
        }
      });
    }),
    //  编辑
    editForm: (0, _validate.Debounce)(function (name) {
      var _this3 = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          if (!_this3.ruleForm.activityName) {
            _this3.$message.info("请填写活动名称");

            return;
          }

          if (!_this3.termTime) {
            _this3.$message.info("请填写活动时间");

            return;
          }

          _this3.ruleForm.activityStartime = _this3.termTime[0];
          _this3.ruleForm.activityEndtime = _this3.termTime[1];
          (0, _marketing.activityEditApi)(_this3.ruleForm).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee2() {
            return _index.default.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _this3.$message.success('编辑成功');

                    _this3.dialogFormVisible = false;

                    _this3.$emit("tableList");

                    _this3.clearFrom();

                    _this3.resetForm(name);

                    _this3.id = 0;

                  case 6:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          })));
        } else {
          return false;
        }
      });
    })
  }
};
exports.default = _default;